export const SET_SELECTED_KPI = "SET_SELECTED_KPI";
export const SET_ORGANIZATIONAL_TAGS = "SET_ORGANIZATIONAL_TAGS";
export const SET_KPI_TAGS = "SET_KPI_TAGS";
export const SET_EXCEL_FILES = "SET_EXCEL_FILES";
export const SET_DATAHUB_DATASET = "SET_DATAHUB_DATASET";
export const SET_DATASET_KPI_YEAR = "SET_DATASET_KPI_YEAR";
export const SET_DATAHUB_DATASET_KPI_DATA = "SET_DATAHUB_DATASET_KPI_DATA";
export const SET_DATAHUB_DATASET_KPI_DATA_FOR_APPROVAL_FLOW =
  "SET_DATAHUB_DATASET_KPI_DATA_FOR_APPROVAL_FLOW";

export const SET_KPI_GROUPS_FOR_DATASETS = "SET_KPI_GROUPS_FOR_DATASETS";
export const SET_KPI_GROUPS_FOR_FREQUENCY = "SET_KPI_GROUPS_FOR_FREQUENCY";

// Datahub
export const SET_DATAHUB_TAB = "SET_DATAHUB_TAB";
export const SET_EXCEL_FILE_DATA = "SET_EXCEL_FILE_DATA";

export const SET_FRAMEWORK_DISCLOSURES = "SET_FRAMEWORK_DISCLOSURES";
export const SET_DATAHUB_FRAMEWORKS = "SET_DATAHUB_FRAMEWORKS";
export const SET_DATAHUB_KPI_GROUP_FILTER = "SET_DATAHUB_KPI_GROUP_FILTER";
export const SET_FRAMEWORK_DRAWER_DATA = "SET_FRAMEWORK_DRAWER_DATA";
export const SET_FRAMEWORK_DRAWER_OPEN = "SET_FRAMEWORK_DRAWER_OPEN";

// RESET COLUMNS PROPS

export const SET_COLUMN_VISIBILITY = "SET_COLUMN_VISIBILITY";
export const UPDATE_COLUMN_VISIBILITY = "UPDATE_COLUMN_VISIBILITY";
export const RESET_COLUMN_VISIBILITY = "RESET_COLUMN_VISIBILITY";

//RESET COLOUMN FOR DATSET

export const SET_DATAHUB_ITEMS = "SET_DATAHUB_ITEMS";
export const UPDATE_DATAHUB_ITEM = "UPDATE_DATAHUB_ITEM";
export const REORDER_DATAHUB_ITEMS = "REORDER_DATAHUB_ITEMS";
export const BATCH_UPDATE_DATAHUB_ITEMS = "BATCH_UPDATE_DATAHUB_ITEMS";

//DRAG AND DROP FOR KPIMASTER
export const SET_COLUMN_ORDER = "SET_COLUMN_ORDER";
export const UPDATE_COLUMN_ORDER = "UPDATE_COLUMN_ORDER";
